import React from 'react'
import '../scss/Loading.scss'
const Loading = () => {
    return (
        <div className='SECTION'>
            
        </div>
    )
}

export default Loading